import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Security = () => {
    const { t } = useLanguage();

    const securityFeatures = [
        { icon: '🔐', text: t('security.features.encrypted') },
        { icon: '👥', text: t('security.features.access') },
        { icon: '📋', text: t('security.features.audit') },
        { icon: '✓', text: t('security.features.compliance') }
    ];

    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#F9F9F9',
        },
        container: {
            maxWidth: '1100px',
            margin: '0 auto',
            textAlign: 'center',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '48px',
            color: '#2B2B2B',
        },
        highlight: {
            color: '#3457D5',
        },
        card: {
            backgroundColor: '#FFFFFF',
            padding: '48px',
            borderRadius: '24px',
            border: '1px solid #E5E5E5',
        },
        intro: {
            fontSize: '24px',
            color: '#414141',
            marginBottom: '40px',
            lineHeight: '1.7',
        },
        accentText: {
            color: '#3457D5',
            fontWeight: '700',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '24px',
        },
        featureCard: {
            backgroundColor: '#F9F9F9',
            padding: '32px 20px',
            borderRadius: '16px',
            border: '1px solid #E5E5E5',
            transition: 'all 0.3s',
        },
        icon: {
            fontSize: '40px',
            marginBottom: '16px',
        },
        featureText: {
            fontSize: '15px',
            color: '#414141',
            lineHeight: '1.6',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.intro.fontSize = '18px';
        styles.grid.gridTemplateColumns = 'repeat(2, 1fr)';
        styles.card.padding = '32px 24px';
    }

    return (
        <section style={styles.section} id="security">
            <div style={styles.container}>
                <h2 style={styles.h2}>
                    {t('security.title')}<span style={styles.highlight}>{t('security.titleHighlight')}</span>
                </h2>

                <div style={styles.card}>
                    <p style={styles.intro}>
                        {t('security.intro')}<span style={styles.accentText}>{t('security.introHighlight')}</span>
                    </p>

                    <div style={styles.grid}>
                        {securityFeatures.map((feature, index) => (
                            <div
                                key={index}
                                style={styles.featureCard}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#3457D5';
                                    e.currentTarget.style.backgroundColor = '#E4ECFF';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#E5E5E5';
                                    e.currentTarget.style.backgroundColor = '#F9F9F9';
                                }}
                            >
                                <div style={styles.icon}>{feature.icon}</div>
                                <p style={styles.featureText}>{feature.text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Security;
